export default "__VITE_ASSET__22d5b66f__"